
import { seo, footer } from '../customWhiteLabel'
export default {
  data() {
    return {
      seo,
      footer,
    }
  },
}
